import React from 'react'
import NaBar from "../components/NavBar";
import HeroImg2 from "../components/HeroImg2";
import Form from "../components/Form";
import Footer from "../components/Footer";



const Contact = () => {
  return (
    <div>
      <NaBar/>
      <HeroImg2 heading="יצירת קשר" text= "" />
      <Form/>
      <Footer/>
      
    </div>
  );
}

export default Contact
